import flightResourceRoutes from '@/flightResource/router'
import hotelResourceRoutes from '@/hotelResource/router'
import hongkongimprintRoutes from '@/hongkongimprint/router'
import { registerNavigationGuard } from '@/router/guard'
import ticketResourceRoutes from '@/ticketResource/router'
import trainResourceRoutes from '@/trainResource/router'
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

const VITE_ROUTE_PATH = import.meta.env.VITE_ROUTE_PATH
const VITE_ROUTER_HISTORY = import.meta.env.VITE_ROUTER_HISTORY

/** 系统页面 */
export const systemRoutes = [
  {
    path: '/403',
    component: () => import('@/pages/error/403.vue'),
    name: '403',
    meta: {
      title: '403',
    },
  },
  {
    path: '/404',
    component: () => import('@/pages/error/404.vue'),
    name: '404',
    meta: {
      title: '404',
    },
    alias: '/:pathMatch(.*)*',
  },
]

/** 业务页面 */
export const routes = [
  {
    path: '/',
    component: () => import('@/pages/home/index.vue'),
    name: 'Home',
    meta: {
      title: '首页',
      layout: {
        navBar: {
          showNavBar: false,
          showLeftArrow: false,
        },
        tabbar: {
          showTabbar: true,
          icon: 'home-o',
        },
      },
    },
  },
  {
    path: '/storeDetails',
    component: () => import('@/pages/storeDetails/index.vue'),
    name: 'StoreDetails',
    meta: {
      title: '门市详情',
    },
  },
  {
    path: '/trip',
    component: () => import('@/pages/trip/TripDetail.vue'),
    name: 'TripDetail',
    meta: {
      title: '行程详情',
      layout: {
        navBar: {
          showNavBar: false,
          showLeftArrow: false,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
  },
  {
    path: '/confirmOrder',
    name: 'ConfirmOrder',
    component: () => import('@/pages/appleBook/confirmOrder.vue'),
    meta: { title: '确认订单' },
  },
  {
    path: '/product',
    component: () => import('@/pages/product/index.vue'),
    name: 'Product',
    meta: {
      title: '产品详情',
    },
    children: [
      {
        path: 'specialOffer',
        name: 'specialOffer',
        component: () => import('@/pages/product/components/specialOffer.vue'),
        meta: {
          title: '活动优惠',
        },
      },
      {
        path: 'couponActivity',
        name: 'couponActivity',
        component: () => import('@/pages/product/components/couponActivity.vue'),
        meta: {
          title: '领券活动',
        },
      },
    ],
  },
  {
    path: '/productList/CityList',
    component: () => import('@/pages/productList/CityList.vue'),
    name: 'CityList',
    meta: {
      title: '国家/地区',
      layout: {
        navBar: {
          showNavBar: false,
          showLeftArrow: false,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
  },
  {
    path: '/visaList',
    name: 'visaList',
    component: () => import('@/pages/visaList/index.vue'),
    meta: { title: '' },
  },
  {
    path: '/static-page/openClawGuide',
    name: 'openClawGuide',
    component: () => import('@/pages/openClawGuide/index.vue'),
    meta: { title: 'OpenClaw Skills 接入指南' },
  },
  {
    path: '/personlnfo',
    component: () => import('@/pages/person/index.vue'),
    name: 'Personlnfo',
    meta: {
      title: '个人基本信息',
    },
  },

  {
    path: '/publishPost',
    component: () => import('@/pages/creation/center/publishPost.vue'),
    name: 'publishPost',
    meta: {
      title: '发布图文',
      isKeepAlive: true,
    },
  },
  {
    path: '/editPost',
    component: () => import('@/pages/creation/center/editPost.vue'),
    name: 'editPost',
    meta: {
      title: '编辑图文',
      isKeepAlive: true,
    },
  },
  {
    path: '/followList',
    component: () => import('@/pages/creation/center/followList.vue'),
    name: 'followList',
    meta: {
      title: '关注列表',
      isKeepAlive: true,
    },
  },
  {
    path: '/personalPage',
    component: () => import('@/pages/creation/center/personalPage.vue'),
    name: 'personalPage',
    meta: {
      title: '查看他人主页',
      isKeepAlive: true,
      isBack: false,
    },
  },
  {
    path: '/draft',
    component: () => import('@/pages/creation/center/draft.vue'),
    name: 'draft',
    meta: {
      title: '草稿箱',
    },
  },
  {
    path: '/shareDetail',
    component: () => import('@/pages/creation/center/shareDetail.vue'),
    name: 'shareDetail',
    meta: {
      title: '分享详情',
      isKeepAlive: true,
    },
  },
  {
    path: '/membership/agreement',
    component: () => import('@/pages/agreement/index.vue'),
    name: 'membershipAgreement',
    meta: {
      title: '中旅旅行会员协议',
    },
  },

  {
    path: '/creation/detail',
    component: () => import('@/pages/creation/detail'),
    name: 'detail',
    meta: {
      title: '图文详情',
    },
  },
  {
    path: '/commonly',
    component: () => import('@/pages/commonly/index.vue'),
    name: 'commonly',
    meta: {
      title: '选择旅客',
    },
  },
  {
    path: '/passengerEdit',
    name: 'passengerEdit',
    component: () => import('@/pages/commonly/passengerEdit.vue'),
    meta: { title: '添加旅客信息' },
  },
  {
    path: '/destinationDetail',
    name: 'Destination',
    component: () => import('@/pages/destination/destinationDetail.vue'),
    meta: { title: '目的地详情' },
  },
  {
    path: '/destinationList',
    name: 'destinationList',
    component: () => import('@/pages/destination/destinationList.vue'),
    meta: { title: '目的地文化列表', isKeepAlive: true },
  },
  {
    path: '/myother',
    name: 'Myother',
    component: () => import(/* webpackChunkName: "Myother" */ '@/pages/myother/index.vue'),
    redirect: '/myother/information',
    children: [
      {
        path: 'information',
        component: () =>
          import(/* webpackChunkName: "Myother" */ '@/pages/myother/information/index.vue'),
        name: 'MyotherInformation',
        meta: {
          title: '常用信息',
        },
      },
      {
        path: 'passenger',
        component: () =>
          import(/* webpackChunkName: "Myother" */ '@/pages/myother/passenger/index.vue'),
        name: 'MyotherPassenger',
        meta: {
          title: '新增旅客信息',
        },
      },
      {
        path: 'instructions',
        component: () =>
          import(/* webpackChunkName: "Myother" */ '@/pages/myother/instructions/index.vue'),
        name: 'MyotherInstructions',
        meta: {
          title: '姓名填写说明',
        },
      },
      {
        path: 'address',
        component: () =>
          import(/* webpackChunkName: "Myother" */ '@/pages/myother/address/index.vue'),
        name: 'MyotherAddress',
        meta: {
          title: '新增地址信息',
        },
      },
      {
        path: 'invoice',
        component: () =>
          import(/* webpackChunkName: "Myother" */ '@/pages/myother/invoice/index.vue'),
        name: 'MyotherInvoice',
        meta: {
          title: '新增发票信息',
        },
      },
    ],
  },

  {
    path: '/aboutTravel',
    name: 'AboutTravel',
    component: () => import('@/pages/aboutTravel/index.vue'),
    redirect: '/aboutTravel/service',
    children: [
      {
        path: 'service',
        component: () =>
          import(/* webpackChunkName: "AboutTravel" */ '@/pages/aboutTravel/service/index.vue'),
        name: 'AboutTravelService',
        meta: {
          title: '关于中旅',
        },
      },
      {
        path: 'about',
        component: () =>
          import(/* webpackChunkName: "AboutTravel" */ '@/pages/aboutTravel/about/index.vue'),
        name: 'AboutTravelAbout',
        meta: {
          title: '关于中旅',
        },
      },
      {
        path: 'contactus',
        component: () =>
          import(/* webpackChunkName: "AboutTravel" */ '@/pages/aboutTravel/contactus/index.vue'),
        name: 'AboutTravelContactus',
        meta: {
          title: '联系我们',
        },
      },
      {
        path: 'mainbusiness',
        component: () =>
          import(
            /* webpackChunkName: "AboutTravel" */ '@/pages/aboutTravel/mainbusiness/index.vue'
          ),
        name: 'AboutTravelMainBusiness',
        meta: {
          title: '主营业务',
        },
      },
      {
        path: 'partyconstruction',
        component: () =>
          import(
            /* webpackChunkName: "AboutTravel" */ '@/pages/aboutTravel/partyconstruction/index.vue'
          ),
        name: 'AboutTravelPartyconstruction',
        meta: {
          title: '党建工作',
        },
      },
      {
        path: 'partyDetail/:type',
        component: () =>
          import(/* webpackChunkName: "AboutTravel" */ '@/pages/aboutTravel/partyDetail/index.vue'),
        name: 'AboutPartyDetail',
        meta: {
          title: '党建工作详情',
        },
      },
    ],
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/pages/aboutUs/index.vue'),
    meta: { title: '关于中旅旅行' },
  },
  {
    path: '/guide',
    name: 'Guide',
    component: () => import('@/pages/guide/index.vue'),
    redirect: '/guide/authentication',
    children: [
      {
        path: 'authentication',
        component: () => import('@/pages/guide/authentication/index.vue'),
        name: 'authentication',
        meta: {
          title: '身份认证',
        },
      },
      {
        path: 'certification',
        component: () => import('@/pages/guide/certification/index.vue'),
        name: 'GuideCertification',
        meta: {
          title: '导游资质认证',
        },
      },
      {
        path: 'explanation',
        component: () => import('@/pages/guide/explanation/index.vue'),
        name: 'GuideExplanation',
        meta: {
          title: '讲解风格',
        },
      },
      {
        path: 'introduction',
        component: () => import('@/pages/guide/introduction/index.vue'),
        name: 'GuideIntroduction',
        meta: {
          title: '个人介绍',
        },
      },
      {
        path: 'scenic',
        component: () => import('@/pages/guide/scenic/index.vue'),
        name: 'GuideScenic',
        meta: {
          title: '请选择擅长景博',
        },
      },
      {
        path: 'person',
        component: () => import('@/pages/guide/person/index.vue'),
        name: 'GuidePerson',
        meta: {
          title: '个人资料',
        },
      },

      {
        path: 'auditresult',
        component: () => import('@/pages/guide/auditresult/index.vue'),
        name: 'auditresult',
        meta: {
          title: '审核结果',
        },
      },
    ],
  },
  {
    path: '/cruise',
    name: 'Cruise',
    component: () => import('@/pages/cruise/index.vue'),
    redirect: '/cruise/encyclopedia',
    children: [
      {
        path: 'encyclopedia',
        component: () =>
          import(/* webpackChunkName: "Cruise" */ '@/pages/cruise/encyclopedia/index.vue'),
        name: 'CruiseEncyclopedia',
        meta: {
          title: '邮轮百科',
        },
      },
      {
        path: 'detail',
        component: () => import(/* webpackChunkName: "Cruise" */ '@/pages/cruise/detail/index.vue'),
        name: 'CruiseDetail',
        meta: {
          title: '邮轮百科详情',
        },
      },
    ],
  },
  {
    path: '/creation',
    name: 'Creation',
    component: () => import('@/pages/creation/index.vue'),
    redirect: '/creation/center',
    children: [
      {
        path: 'center',
        component: () => import('@/pages/creation/center/index.vue'),
        name: 'Center',
        meta: {
          title: '个人主页',
          isKeepAlive: true,
        },
      },
      {
        path: 'creatorDetail',
        component: () => import('@/pages/creation/center/creatorDetail.vue'),
        name: 'creatorDetail',
        meta: {
          title: '达人详情',
        },
      },
      {
        path: 'growthDetail',
        component: () => import('@/pages/creation/center/growthDetail.vue'),
        name: 'creationGrowthDetail',
        meta: {
          title: '成长值明细',
        },
      },

      {
        path: 'selectScenic',
        component: () => import('@/pages/creation/center/selectScenic.vue'),
        name: 'selectScenic',
        meta: {
          title: '关联景点',
        },
      },
      {
        path: 'selectProduct',
        component: () => import('@/pages/creation/center/selectProduct.vue'),
        name: 'selectProduct',
        meta: {
          title: '关联产品',
        },
      },
      {
        path: 'selectCity',
        component: () => import('@/pages/creation/center/selectCity.vue'),
        name: 'selectCity',
        meta: {
          title: '选择城市',
        },
      },
      {
        path: 'travelHistory',
        component: () => import('@/pages/creation/center/travelHistory.vue'),
        name: 'travelHistory',
        meta: {
          title: '我的历史行程',
        },
      },
      {
        path: 'upList',
        component: () => import('@/pages/creation/center/upList.vue'),
        name: 'upList',
        meta: {
          title: '我赞过的',
        },
      },
      {
        path: 'report',
        component: () => import('@/pages/creation/center/report.vue'),
        name: 'report',
        meta: {
          title: '举报',
        },
      },

      {
        path: 'report-contract',
        component: () => import('@/pages/creation/center/report-contract.vue'),
        name: 'report-contract',
        meta: {
          title: '中旅社区举报及相关事宜说明',
        },
      },
      {
        path: 'BrowserHistory',
        component: () => import('@/pages/creation/center/BrowserHistory.vue'),
        name: 'BrowserHistory',
        meta: {
          title: '浏览记录',
          isKeepAlive: true,
        },
      },
      {
        path: 'myCollect',
        component: () => import('@/pages/creation/center/myCollect.vue'),
        name: 'myCollect',
        meta: {
          title: '收藏',
          isKeepAlive: true,
        },
      },
    ],
  },
  {
    path: '/liveStream/report',
    component: () => import('@/pages/liveStreamReport/index.vue'),
    name: 'liveStreamReport',
    meta: {
      title: '举报',
    },
  },
  {
    path: '/liveStream/report-contract',
    component: () => import('@/pages/liveStreamReport/report-contract.vue'),
    name: 'liveStreamReportContract',
    meta: {
      title: '中旅社区举报及相关事宜说明',
    },
  },
  {
    path: '/userBehavior',
    component: () => import('@/pages/behavior/index.vue'),
    name: 'UserBehavior',
    meta: {
      title: '用户行为信息',
    },
  },
  {
    path: '/deviceInfor',
    component: () => import('@/pages/device/index.vue'),
    name: 'DeviceInfor',
    meta: {
      title: '设备与位置信息',
    },
  },
  {
    path: '/scenery/appPrivacy',
    name: 'appPrivacy',
    component: () => import('@/pages/privacyPolicy/scenery/privacy.vue'),
    meta: { title: '隐私政策' },
  },
  {
    path: '/scenery/userAgreement',
    name: 'userAgreement',
    component: () => import('@/pages/privacyPolicy/scenery/userAgreement.vue'),
    meta: { title: '用户协议' },
  },
  {
    path: '/productLevel',
    name: 'productLevel',
    component: () => import('@/pages/product/level.vue'),
    meta: { title: '产品等级' },
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import('@/pages/privacyPolicy'),
    meta: { title: '隐私政策' },
  },
  {
    path: '/privacyThirdSdk',
    name: 'privacyThirdSdk',
    component: () => import('@/pages/privacyPolicy/privacyThirdSdk'),
    meta: { title: '第三方SDK信息表' },
  },
  {
    path: '/authAgreement',
    name: 'authAgreement',
    component: () => import('@/pages/authAgreement'),
    meta: { title: '认证授权协议' },
  },
  {
    path: '/paymentContract',
    component: () => import('@/pages/paymentContract'),
    meta: { title: '签约付款' },
  },
  {
    path: '/instructions/:productId',
    name: 'Instructions',
    component: () => import(/* webpackChunkName: "instructions" */ '@/pages/instructions'),
    meta: { title: '购买须知' },
  },
  {
    path: '/product/success/:memberId/:orderId',
    component: () => import(/* webpackChunkName: "success" */ '@/pages/product/success.vue'),
    meta: { title: '预订成功' },
  },
  {
    path: '/memberCenter',
    component: () => import('@/pages/memberCenter/index.vue'),
    name: 'MemberCenter',
    meta: {
      title: '会员中心',
    },
  },
  {
    path: '/memberInstruction',
    component: () => import('@/pages/memberCenter/memberInstruction.vue'),
    name: 'MemberInstruction',
    meta: {
      title: '会员说明',
    },
  },
  // 积分规则
  {
    path: '/pointRule',
    component: () => import('@/pages/memberCenter/pointRule.vue'),
    name: 'PointRule',
    meta: {
      title: '积分规则',
    },
  },
  // 积分明细
  {
    path: '/pointDetail',
    component: () => import('@/pages/memberCenter/pointDetail/index.vue'),
    name: 'PointDetail',
    meta: {
      title: '积分明细',
    },
  },
  // 成长值明细
  {
    path: '/growthDetail',
    component: () => import('@/pages/memberCenter/growthDetail.vue'),
    name: 'GrowthDetail',
    meta: {
      title: '成长值明细',
    },
  },
  // 积分抵现
  {
    path: '/pointsRedemption',
    // component: () => import('@/pages/pointsRedemption/index.vue'),
    component: () => import('@/pages/pointsRedemption/pointsCenter.vue'),
    name: 'PointsRedemption',
    meta: {},
  },
  // 邀请活动
  {
    path: '/inviteActivity',
    component: () => import('@/pages/inviteActivity/index.vue'),
    name: 'InviteActivity',
    meta: {
      title: '邀请活动',
    },
  },
  // 积分详情
  {
    path: '/pointsDetails',
    component: () => import('@/pages/pointsDetails/index.vue'),
    name: 'PointsDetails',
    redirect: '/pointDetail',
    meta: {
      title: '积分详情',
    },
  },
  {
    path: '/visaList',
    name: 'visaList',
    component: () => import('@/pages/visaList/index.vue'),
    meta: { title: '' },
  },
  {
    path: '/materialDetail',
    name: 'materialDetail',
    component: () => import('@/pages/visaDetail/materialDetail.vue'),
    meta: { title: '材料详情' }, // 签证材料详情页
  },
  {
    path: '/transactFlowDetail',
    name: 'transactFlowDetail',
    component: () => import('@/pages/visaDetail/transactFlowDetail.vue'),
    meta: { title: '办理流程' }, // 签证办理流程详情页
  },
  {
    path: '/visaModule',
    component: () => import('@/pages/visaModule/index.vue'),
    name: 'visaModule',
    meta: { title: '签证', isKeepAlive: true },
  },
  {
    path: '/visaDescription',
    component: () => import('@/pages/visaModule/visaDescription.vue'),
    name: 'visaDescription',
    meta: { title: '签证说明', isKeepAlive: true },
  },
  {
    path: '/visaQuestions',
    component: () =>
      import(/* webpackChunkName: "instructions" */ '@/pages/visaModule/visaQuestions.vue'),
    meta: { title: '常见问题' },
  },
  {
    path: '/visaNotes',
    component: () =>
      import(/* webpackChunkName: "instructions" */ '@/pages/visaModule/visaNotes.vue'),
    meta: { title: '签证须知' },
  },
  {
    path: '/visaSense',
    component: () =>
      import(/* webpackChunkName: "instructions" */ '@/pages/visaModule/visaSense.vue'),
    meta: { title: '签证常识' },
  },
  {
    path: '/convalesce',
    children: [
      {
        path: 'certification',
        component: () => import('@/pages/convalesce/certification/index.vue'),
        meta: { title: '认证' },
      },
      {
        path: 'certification/welcome',
        component: () => import('@/pages/convalesce/certification/welcome.vue'),
        meta: { title: '认证' },
      },
      {
        path: 'announcement',
        component: () => import('@/pages/convalesce/announcement/index.vue'),
        meta: { title: '公告', isKeepAlive: true },
      },
      {
        path: 'announcement/detail',
        component: () => import('@/pages/convalesce/announcement/detail.vue'),
        meta: { title: '公告详情' },
      },
      {
        path: 'questions',
        component: () => import('@/pages/convalesce/questions/index.vue'),
        meta: { title: '常见问题' },
      },
      {
        path: 'enterpriseMoney',
        component: () => import('@/pages/convalesce/enterpriseMoney/index.vue'),
        // 标题由组件内请求接口后设置
        meta: { title: '明细' },
      },
      {
        path: 'personalInfo',
        component: () => import('@/pages/convalesce/personalInfo/index.vue'),
        meta: { title: '个人信息' },
      },
      {
        path: 'privacy',
        component: () => import('@/pages/convalesce/privacy/index.vue'),
        meta: { title: '企业疗养服务须知' },
      },
      {
        path: 'travelPage',
        alias: '/travelPage',
        component: () => import('@/pages/convalesce/travelPage/index.vue'),
        meta: { title: '旅游' },
      },
      {
        path: 'homepage',
        component: () => import('@/pages/convalesce/homepage/index.vue'),
        meta: { title: '疗休养首页' },
        redirect: '/convalesce/homepage/home',
        children: [
          {
            path: 'home',
            component: () => import('@/pages/convalesce/homepage/home/index.vue'),
            meta: { title: '企业疗养专区' },
          },
          {
            path: 'selfCenter',
            component: () => import('@/pages/convalesce/homepage/selfCenter/index.vue'),
            meta: { title: '我的' },
          },
        ],
      },
    ],
  },
  {
    path: '/visaBook',
    name: 'visaBook',
    component: () => import('@/pages/visaBook/index.vue'),
    meta: { title: '预订产品' }, // 签证预订页
  },
  {
    path: '/tailoredTravel',
    component: () => import(/* webpackChunkName: "success" */ '@/pages/tailoredTravel/index.vue'),
    meta: { title: '定制游' },
  },
  // 企业定制
  {
    path: '/entercustomiza',
    component: () => import('@/pages/enterpriseCustom/index.vue'),
    name: 'Entercustomiza',
    meta: {
      title: '企业定制',
    },
  },
  // 热门城市
  {
    path: '/hotCity',
    component: () => import('@/pages/hotcity/index.vue'),
    name: 'HotCity',
    meta: {
      title: '热门城市',
    },
  },
  {
    path: '/tailoredTravel/customizerDetail',
    component: () =>
      import(/* webpackChunkName: "success" */ '@/pages/tailoredTravel/customizerDetail.vue'),
    meta: { title: '定制师详情' },
  },
  {
    path: '/tailoredTravel/myCustomList',
    component: () =>
      import(/* webpackChunkName: "success" */ '@/pages/tailoredTravel/myCustomList.vue'),
    meta: { title: '我的定制' },
  },
  {
    path: '/coupon',
    component: () => import(/* webpackChunkName: "success" */ '@/pages/coupon/index.vue'),
    meta: { title: '优惠券' },
  },
  {
    path: '/myCoupon',
    component: () => import(/* webpackChunkName: "success" */ '@/pages/coupon/myCoupon.vue'),
    meta: { title: '我的优惠券', isKeepAlive: true },
  },
  {
    path: '/myCouponHistory',
    component: () => import(/* webpackChunkName: "success" */ '@/pages/coupon/myCouponHistory.vue'),
    meta: { title: '优惠券历史记录' },
  },
  {
    path: '/couponRulesDetail',
    component: () =>
      import(/* webpackChunkName: "success" */ '@/pages/coupon/couponRulesDetail.vue'),
    meta: { title: '券详情' },
  },
  {
    path: '/tailored',
    name: 'tailored',
    component: () =>
      import(/* webpackChunkName: "tailoredAssistant" */ '@/pages/tailored/index.vue'),
    redirect: '/tailoredAssistant',
    children: [
      {
        path: '/tailoredAssistant',
        name: 'tailoredAssistant',
        component: () =>
          import(/* webpackChunkName: "tailoredAssistant" */ '@/pages/tailored/tailored.vue'),
        meta: {
          title: '中旅定制小助手',
          isKeepAlive: true, //需要被缓存
        },
      },
    ],
  },
  {
    path: '/orderlist/:id?',
    name: 'orderlist',
    component: () => import(/* webpackChunkName: "orderlist" */ '@/pages/orderList/index.vue'),
    meta: { title: '订单列表' },
  },
  {
    path: '/contact',
    name: 'contact',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/pages/orderList/components/Contact.vue'),
    meta: { title: '出游人信息' },
  },
  {
    path: '/signpayment',
    name: 'signpayment',
    component: () =>
      import(/* webpackChunkName: "signpayment" */ '@/pages/orderList/SignPayment.vue'),
    meta: { title: '订单详情' },
  },

  {
    path: '/traveldata',
    name: 'traveldata',
    component: () =>
      import(/* webpackChunkName: "traveldata" */ '@/pages/orderList/components/TravelData.vue'),
    meta: { title: '中旅旅行旅游服务条款' },
  },
  {
    path: '/realNameAuth',
    name: 'realNameAuth',
    component: () =>
      import(/* webpackChunkName: "realNameAuth" */ '@/pages/realNameAuth/index.vue'),
    meta: { title: '实名认证授权协议' },
  },
  {
    path: '/pdf',
    name: 'contract',
    component: () => import(/* webpackChunkName: "pdf" */ '@/pages/orderList/pdf.vue'),
    meta: { title: '签约行程' },
  },
  {
    path: '/pdf',
    name: 'notive',
    component: () => import(/* webpackChunkName: "pdf" */ '@/pages/orderList/pdf.vue'),
    meta: { title: '出游通知书' },
  },
  {
    path: '/signpayment/submitSuccess',
    name: 'submitSuccess',
    component: () =>
      import(
        /* webpackChunkName: "submitSuccess" */ '@/pages/orderList/components/SubmitSuccess.vue'
      ),
    meta: { title: '取消成功' },
  },
  {
    path: '/signpayment/payWin/:orderId?/:id?/:value?',
    name: 'payWin',
    component: () =>
      import(/* webpackChunkName: "payWin" */ '@/pages/orderList/components/PayWin.vue'),
    meta: { title: '付款成功' },
  },
  {
    path: '/signpayment/payFail/:orderId?/:id?',
    name: 'payFail',
    component: () =>
      import(/* webpackChunkName: "payFail" */ '@/pages/orderList/components/PayFail.vue'),
    meta: { title: '付款失败' },
  },
  {
    path: '/signpayment/gradationpay/:orderId?/:id?/:value?',
    name: 'gradationPay',
    component: () =>
      import(
        /* webpackChunkName: "gradationpay" */ '@/pages/orderList/components/GradationPay.vue'
      ),
    meta: { title: '付款成功' },
  },
  {
    path: '/wellnessPay',
    name: 'wellnessPay',
    component: () =>
      import(/* webpackChunkName: "wellnessPay" */ '@/pages/orderList/wellnessPay.vue'),
    meta: { title: '疗休养专区收银台' },
  },
  {
    path: '/externalRedirect',
    name: 'externalRedirect',
    component: () =>
      import(/* webpackChunkName: "externalRedirect" */ '@/pages/orderList/components/ExternalRedirect.vue'),
    meta: { title: '跳转中' },
  },
  // 云店小程序进入的详情页
  {
    path: '/order/:orderId/:shopkeeperId/:superior',
    name: 'order',
    component: () =>
      import(/* webpackChunkName: "cloudStoreOrder" */ '@/pages/orderList/Details.vue'),
    meta: { title: '订单详情' },
  },
  {
    path: '/hotelOrderDetail',
    name: 'hotelOrderDetail',
    component: () => import('@/pages/orderList/hotelOrderDetail.vue'),
    meta: { title: '订单详情' },
  },
  {
    path: '/visaOrderDetail',
    name: 'visaOrderDetail',
    component: () => import('@/pages/orderList/visaOrderDetail.vue'),
    meta: { title: '订单详情', bgColor: '#E8EBED' },
  },
  {
    // 团办流程
    path: '/visaApplicantDetail',
    name: 'visaApplicantDetail',
    component: () => import('@/pages/orderList/visaApplicantDetail.vue'),
    meta: { title: '办理流程' },
  },
  {
    // 单办流程
    path: '/visaSingleApply',
    name: 'visaSingleApply',
    component: () => import('@/pages/orderList/visaSingleApply.vue'),
    meta: { title: '办理流程', bgColor: '#E8EBED', keepAlive: false },
  },
  {
    // 材料上传列表
    path: '/uploadFileList',
    name: 'uploadFileList',
    component: () => import('@/pages/orderList/uploadFileList.vue'),
    meta: { title: '上传材料', bgColor: '#E8EBED', isBack: true },
  },
  {
    // 查看上传列表
    path: '/qryFileList',
    name: 'qryFileList',
    component: () => import('@/pages/orderList/uploadFileList.vue'),
    meta: { title: '查看材料', bgColor: '#E8EBED', isBack: true },
  },
  {
    // 单个材料上传
    path: '/uploadVisaFile',
    name: 'uploadVisaFile',
    component: () => import('@/pages/orderList/uploadVisaFile.vue'),
    meta: { title: '上传材料', bgColor: '#E8EBED' },
  },
  {
    // 单个材料查看
    path: '/qryUploadFile',
    name: 'qryUploadFile',
    component: () => import('@/pages/orderList/uploadVisaFile.vue'),
    meta: { title: '查看材料', bgColor: '#E8EBED' },
  },
  {
    // 填写寄件物流信息
    path: '/submitTransferInfo',
    name: 'submitTransferInfo',
    component: () => import('@/pages/orderList/submitTransferInfo.vue'),
    meta: { title: '填写寄件物流信息', bgColor: '#E8EBED', isBack: true },
  },
  {
    // 历史物流信息列表
    path: '/transferInfoHistory',
    name: 'transferInfoHistory',
    component: () => import('@/pages/orderList/transferInfoHistory.vue'),
    meta: { title: '历史物流信息', bgColor: '#E8EBED' },
  },
  {
    // 更多寄件物流信息列表
    path: '/moreTransferInfo',
    name: 'moreTransferInfo',
    component: () => import('@/pages/orderList/transferInfoHistory.vue'),
    meta: { title: '更多物流信息', bgColor: '#E8EBED' },
  },
  {
    // 查看寄件人物流信息
    path: '/transferInfoDetail',
    name: 'transferInfoDetail',
    component: () => import('@/pages/orderList/submitTransferInfo.vue'),
    meta: { title: '查看寄件物流信息', bgColor: '#E8EBED', isBack: true },
  },
  {
    // 查看收件人物流信息
    path: '/receiveInfoDetail',
    name: 'receiveInfoDetail',
    component: () => import('@/pages/orderList/submitTransferInfo.vue'),
    meta: { title: '查看收件物流信息', bgColor: '#E8EBED', isBack: true },
  },
  {
    // 查看物流
    path: '/logisticsDetail',
    name: 'logisticsDetail',
    component: () => import('@/pages/orderList/logisticsDetail.vue'),
    meta: { title: '查看物流信息', bgColor: '#E8EBED' },
  },
  {
    // 查看签证
    path: '/qryVisaFile',
    name: 'qryVisaFile',
    component: () => import('@/pages/orderList/qryVisaFile.vue'),
    meta: { title: '查看签证', bgColor: '#E8EBED', isBack: true },
  },
  {
    path: '/appleOrderDetail',
    name: 'appleOrderDetail',
    component: () => import('@/pages/orderList/appleOrderDetail.vue'),
    meta: { title: '订单详情' },
  },
  {
    path: '/invoiceDeatil',
    name: 'invoiceDeatil',
    component: () => import('@/pages/orderList/invoiceDeatil.vue'),
    meta: { title: '发票详情' },
  },
  {
    path: '/invoicing',
    name: 'invoicing',
    component: () => import('@/pages/orderList/invoicing.vue'),
    meta: { title: '开具发票' },
  },
  {
    path: '/underStock',
    name: 'underStock',
    component: () => import('@/pages/orderList/underStock.vue'),
    meta: { title: '库存不足' },
  },
  {
    path: '/soldOut',
    name: 'soldOut',
    component: () => import('@/pages/orderList/soldOut.vue'),
    meta: { title: '已售罄' },
  },

  {
    path: '/submitComment',
    name: 'submitComment',
    component: () => import('@/pages/comment/submitComment.vue'),
    meta: { title: '订单点评' },
  },
  {
    path: '/myComment',
    name: 'myComment',
    component: () => import('@/pages/comment/myComment.vue'),
    meta: { title: '我的点评' },
  },

  {
    path: '/records',
    name: 'records',
    component: () => import('@/pages/comment/records.vue'),
    meta: { title: '我的中奖记录' },
  },
  {
    path: '/lottery',
    name: 'lottery',
    component: () => import('@/pages/comment/lottery.vue'),
    meta: { title: '抽奖' },
  },
  {
    path: '/rules',
    name: 'rules',
    component: () => import('@/pages/comment/rules.vue'),
    meta: { title: '订单点评规则' },
  },

  // 反馈页面
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/pages/feedback/index.vue'),
    meta: { title: '投诉建议', isKeepAlive: true },
  },
  // 反馈成功页面
  {
    path: '/feedbackSuccess',
    name: 'feedbackSuccess',
    component: () => import('@/pages/feedback/feedbackSuccess.vue'),
    meta: { title: '反馈成功' },
  },

  {
    path: '/activityPage',
    name: 'activityPage',
    component: () => import('@/pages/activityPage/index.vue'),
    meta: { title: '中远海运集运员工福利购' },
  },
  {
    path: '/cruiseInformation/travelTips',
    name: 'cruiseInformationTravelTips',
    component: () => import('@/pages/cruiseInformation/travelTips.vue'),
    meta: { title: '邮轮信息' },
  },
  {
    path: '/cruiseInformation/packingList',
    name: 'cruiseInformationPackingList',
    component: () => import('@/pages/cruiseInformation/packingList.vue'),
    meta: { title: '邮轮信息' },
  },
  {
    path: '/cruiseInformation/serviceFee',
    name: 'cruiseInformationServiceFee',
    component: () => import('@/pages/cruiseInformation/serviceFee.vue'),
    meta: { title: '邮轮信息' },
  },
  {
    path: '/cruiseInformation/evaluation',
    name: 'cruiseInformationEvaluation',
    component: () => import('@/pages/cruiseInformation/evaluation.vue'),
    meta: { title: '邮轮信息' },
  },
  {
    path: '/exportAuthorizationStatement',
    name: 'exportAuthorizationStatement',
    component: () => import('@/pages/exportAuthorizationStatement/index.vue'),
    meta: { title: '个人信息出境授权声明' },
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('@/pages/map/index.vue'),
    meta: { title: '地图' },
  },
  {
    path: '/haoshiguang',
    name: 'haoshiguang',
    component: () => import('@/pages/haoshiguang/index.vue'),
    meta: { title: '好时光' },
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/pages/download/index.vue'),
    meta: { title: '下载APP' },
  },
  { // download 会被微信拦截，所以新增一个sld路由，解决下载问题
    path: '/sld',
    name: 'sld',
    component: () => import('@/pages/download/index.vue'),
    meta: { title: '下载APP' },
  },
  {
    path: '/downloadpc',
    name: 'downloadpc',
    component: () => import('@/pages/downloadpc/index.vue'),
    meta: { title: '下载APP' },
  },
  {
    path: '/dlp',
    name: 'dlp',
    component: () => import('@/pages/download/downloadPromotion.vue'),
    meta: { title: '下载APP' },
  },
  {
    path: '/bdl',
    name: 'bdl',
    component: () => import('@/pages/download/businessDownload.vue'),
    meta: { title: '下载APP' },
  },
  {
    path: '/downloadPromotion',
    name: 'downloadPromotion',
    component: () => import('@/pages/download/downloadPromotion.vue'),
    meta: { title: '下载APP' },
  },
  {
    path: '/cnTripSelected',
    name: 'cnTripSelected',
    component: () => import('@/pages/cnTripSelected/index.vue'),
    meta: { title: '中旅严选' },
  },
  {
    path: '/cnTripSelf',
    name: 'cnTripSelf',
    component: () => import('@/pages/cnTripSelf/index.vue'),
    meta: { title: '中旅自营' },
  },
  {
    path: '/activity',
    name: 'activity',
    component: () => import('@/pages/activity/index.vue'),
    meta: { title: '活动' },
  },
  {
    path: '/hongkongActivity',
    name: 'hongkongActivity',
    component: () => import('@/pages/hongkongActivity/index.vue'),
    meta: { title: '玩转香港' },
  },
  {
    path: '/nearbyStores',
    name: 'nearbyStores',
    component: () => import('@/pages/nearbyStores/index.vue'),
    meta: { title: '附近门市' },
  },
  {
    path: '/experiencePoints',
    name: 'experiencePoints',
    component: () => import('@/pages/experiencePoints/index.vue'),
    meta: { title: '体验分规则说明' },
  },
  {
    path: '/destination/sightDetail',
    name: 'sightDetail',
    component: () => import('@/pages/destination/sightDetail.vue'),
    meta: { title: '景点详情' },
  },
  {
    path: '/destination/imageList',
    name: 'destinationImageList',
    component: () => import('@/pages/destination/imageList.vue'),
    meta: { title: '图集' },
  },
  {
    path: '/destination/preview',
    name: 'destinationPreview',
    component: () => import('@/pages/destination/components/preview.vue'),
    meta: { title: '图集' },
  },
  {
    path: '/guide/news',
    name: 'guideNews',
    component: () => import('@/pages/guide/news/index.vue'),
    meta: { title: '行业资讯' },
  },
  // 权益中心
  {
    path: '/privilegeCenter',
    name: 'PrivilegeCenter',
    component: () => import('@/pages/privilegeCenter/index.vue'),
    meta: { title: '权益中心' },
  },
  // 全部权益页
  {
    path: '/allPrivilege',
    name: 'allPrivilege',
    component: () => import('@/pages/allPrivilege/index.vue'),
    meta: { title: '全部权益' },
  },
  {
    path: '/dashBoard',
    name: 'dashBoard',
    component: () => import('@/pages/dashBoard/index.vue'),
    meta: { title: '数据看板', isKeepAlive: true },
  },
  {
    path: '/dashBoard/detail',
    name: 'dashBoardDetail',
    component: () => import('@/pages/dashBoard/detail.vue'),
    meta: { title: '数据看板详情' },
  },
  {
    path: '/advertise',
    name: 'advertise',
    component: () => import('@/pages/advertise/index.vue'),
    meta: { title: '广告' },
  },
  {
    path: '/customerCoupon',
    name: 'customerCoupon',
    component: () => import('@/pages/customerCoupon/index.vue'),
    meta: { title: '集团客户专享券包' },
  },
  {
    path: '/newJourneyGift',
    name: 'NewJourneyGift',
    component: () => import('@/pages/newJourneyGift/index.vue'),
    meta: { title: '' },
  },
  {
    path: '/coMarketing',
    name: 'CoMarketing',
    component: () => import('@/pages/coMarketing/index.vue'),
    meta: { title: '' },
  },
  {
    path: '/autumnActivity',
    name: 'AutumnActivity',
    component: () => import('@/pages/autumnActivity/index.vue'),
    meta: { title: '金秋赏玩记' },
  },
  {
    path: '/flashSaleActivity',
    name: 'flashSaleActivity',
    component: () => import('@/pages/activities/flashSaleActivity/index.vue'),
    meta: { title: '年味寻踪 乐游新春' },
  },

  {
    path: '/travelDataCenter',
    name: 'travelDataCenter',
    component: () => import('@/pages/travelDataCenter/index.vue'),
    meta: { title: '中旅旅行数据中心', isKeepAlive: true },
  },
  {
    path: '/travelDataCenter/region',
    name: 'regionList',
    component: () => import('@/pages/travelDataCenter/regionList/index.vue'),
    meta: { title: '区域列表', isKeepAlive: false },
  },
  {
    path: '/travelDataCenter/area',
    name: 'areaList',
    component: () => import('@/pages/travelDataCenter/areaList/index.vue'),
    meta: { title: '地区列表', isKeepAlive: false },
  },
  {
    path: '/travelDataCenter/enterprise',
    name: 'enterpriseInfo',
    component: () => import('@/pages/travelDataCenter/enterpriseInfo/index.vue'),
    meta: { title: '企业信息', isKeepAlive: false },
  },
  {
    path: '/travelDataCenter/search',
    name: 'search',
    component: () => import('@/pages/travelDataCenter/search/index.vue'),
    meta: { title: '搜索', isKeepAlive: false },
  },
  {
    path: '/travelDataCenter/salesData',
    name: 'salesData',
    component: () => import('@/pages/travelDataCenter/salesData/index.vue'),
    meta: { title: '国内/出境/入境销售数据', isKeepAlive: false },
  },
  {
    path: '/travelDataCenter/salesRanking',
    name: 'salesRanking',
    component: () => import('@/pages/travelDataCenter/salesRanking/index.vue'),
    meta: { title: 'C端产品销量排名', isKeepAlive: false },
  },
  {
    path: '/travelDataCenter/financeIndicator/total',
    name: 'financeIndicatorTotal',
    component: () => import('@/pages/travelDataCenter/financeIndicator/total/index.vue'),
    meta: { title: '销管费用合计', isKeepAlive: false },
  },
  {
    path: '/travelDataCenter/financeIndicator/sales',
    name: 'financeIndicatorSales',
    component: () => import('@/pages/travelDataCenter/financeIndicator/sales/index.vue'),
    meta: { title: '销售费用', isKeepAlive: false },
  },
  {
    path: '/travelDataCenter/financeIndicator/manage',
    name: 'financeIndicatorManage',
    component: () => import('@/pages/travelDataCenter/financeIndicator/manage/index.vue'),
    meta: { title: '管理费用', isKeepAlive: false },
  },
  {
    path: '/travelDataCenter/financeIndicator/finance',
    name: 'financeIndicatorFinance',
    component: () => import('@/pages/travelDataCenter/financeIndicator/finance/index.vue'),
    meta: { title: '财务费用', isKeepAlive: false },
  },
  {
    path: '/guideList',
    name: 'guideList',
    component: () => import('@/pages/product/components/guide/index.vue'),
    meta: { title: '团队成员', isKeepAlive: false },
  },
  {
    path: '/report/dataMonitor',
    name: 'dataMonitor',
    component: () => import('@/pages/dataMonitor/index.vue'),
    meta: { title: '指标进展监控系统', isKeepAlive: true },
  },
  {
    path: '/report/dataMonitor/businessData',
    name: 'dataMonitorBusinessData',
    component: () => import('@/pages/dataMonitor/businessData/index.vue'),
    meta: { title: '业务指标' },
  },
  {
    path: '/report/dataMonitor/subordinateBusiness',
    name: 'dataMonitorSubBusiness',
    component: () => import('@/pages/dataMonitor/subordinateBusiness/index.vue'),
    meta: { title: '下级业务概述' },
  },
  {
    path: '/report/dataMonitor/ranking',
    name: 'dataMonitorRanking',
    component: () => import('@/pages/dataMonitor/ranking/index.vue'),
    meta: { title: '排行榜' },
  },
  {
    path: '/dashBoardCbc',
    name: 'dashBoardCbc',
    component: () => import('@/pages/dashBoardCbc/index.vue'),
    meta: { title: '建行疗养项目数据看板', isKeepAlive: true },
  },
  {
    path: '/themeParkActivity',
    name: 'ThemeParkActivity',
    component: () => import('@/pages/themeParkActivity/index.vue'),
    meta: { title: '乐园即刻出发' },
  },
  {
    path: '/marketing/springFestivalTopics',
    name: 'springFestivalTopics',
    component: () => import('@/pages/springFestivalTopics/index.vue'),
    meta: { title: '春节就位我先嗨' },
  },
  {
    path: '/marketing/springTravelTopics',
    name: 'springFestivalTopics',
    component: () => import('@/pages/springTravelTopics/index.vue'),
    meta: { title: '全家春游正当时' },
  },
  {
    path: '/marketing/chinaTourismDay',
    name: 'ChinaTourismDay',
    component: () => import('@/pages/ChinaTourismDay/index.vue'),
    meta: { title: '5·19中国旅游日' },
  },
  {
    path: '/marketing/mawangdui',
    name: 'Mawangdui',
    component: () => import('@/pages/Mawangdui/index.vue'),
    meta: { title: '马王堆国宝展览', isKeepAlive: true, },
  },
  {
    path: '/enterpriseCertification',
    name: 'EnterpriseCertification',
    component: () => import('@/pages/enterpriseCertification/index.vue'),
    meta: { title: '企业认证' },
  },
  {
    path: '/enterpriseCertification/form',
    name: 'EnterpriseCertificationForm',
    component: () => import('@/pages/enterpriseCertification/form.vue'),
    meta: { title: '企业认证' },
  },
  {
    path: '/enterpriseCertification/verified',
    name: 'EnterpriseCertificationVerified',
    component: () => import('@/pages/enterpriseCertification/verified.vue'),
    meta: { title: '企业认证' },
  },
  {
    path: '/enterpriseCertification/result',
    name: 'EnterpriseCertificationResult',
    component: () => import('@/pages/enterpriseCertification/result.vue'),
    meta: { title: '邮箱验证' },
  },
  {
    path: '/evergreenCup',
    name: 'evergreenCup',
    component: () => import('@/pages/evergreenCup/index.vue'),
    meta: { title: '常青杯' },
  },
  {
    path: '/evergreenCup/registrationResult',
    name: 'evergreenCupRegistrationResult',
    component: () => import('@/pages/evergreenCup/registrationResult.vue'),
    meta: { title: '报名结果' },
  },
  {
    path: '/evergreenCup/registrationPage',
    name: 'registrationPage',
    component: () => import('@/pages/evergreenCup/registrationPage.vue'),
    meta: { title: '比赛报名', isKeepAlive: true },
  },
  {
    path: '/evergreenCup/registrationAgreement',
    name: 'registrationAgreement',
    component: () => import('@/pages/evergreenCup/registrationAgreement.vue'),
    meta: { title: '协议' },
  },
  {
    path: '/feedback/algorithmicDescriptions',
    name: 'algorithmicDescriptions',
    component: () => import('@/pages/feedback/algorithmicDescriptions.vue'),
    meta: { title: '深度生成合成类算法说明' },
  },
]

/** 路由实例 */
export const router = createRouter({
  history:
    VITE_ROUTER_HISTORY === 'hash'
      ? createWebHashHistory(VITE_ROUTE_PATH)
      : createWebHistory(VITE_ROUTE_PATH),
  routes: [
    ...systemRoutes,
    ...routes,
    ...flightResourceRoutes,
    ...hotelResourceRoutes,
    ...ticketResourceRoutes,
    ...trainResourceRoutes,
    ...hongkongimprintRoutes,
  ],
})

// 注册路由导航守卫
registerNavigationGuard(router)
